/** Whether a sorted list of integers holds `v` (a binary search: cell lists kept sorted in a fight's rules). */
export const binHas = (a: readonly number[], v: number): boolean => {
  let lo = 0;
  let hi = a.length - 1;
  while (lo <= hi) {
    const m = (lo + hi) >> 1;
    const x = a[m] as number;
    if (x === v) return true;
    if (x < v) lo = m + 1;
    else hi = m - 1;
  }
  return false;
};
